import { IconAlertCircle, IconClock, IconOctagonX } from '@developerz/ui';
import { type JSX, Match, Switch } from 'solid-js';
import type { CardState } from '../../lib/machine-card';

// The small mark beside a state's word (#6785, prototype `ST[state].icon`): the live dot
// while it works on its own (the design system's one live dot, `.status__dot`), an amber
// pulse for Needs you, a glyph for Blocked, Paused and Offline, nothing for the quiet rest.
// Decorative: the word beside it names the state, so colour is never the only signal.

export function StateMark(props: { readonly state: CardState }): JSX.Element {
  return (
    <Switch>
      <Match when={props.state === 'autonomous'}>
        <span class="status__dot" aria-hidden="true" />
      </Match>
      <Match when={props.state === 'needs'}>
        <span class="mission-card__pulse-dot" aria-hidden="true" />
      </Match>
      <Match when={props.state === 'blocked'}>
        <IconOctagonX class="mission-card__mark" />
      </Match>
      <Match when={props.state === 'paused'}>
        <IconClock class="mission-card__mark" />
      </Match>
      <Match when={props.state === 'offline'}>
        <IconAlertCircle class="mission-card__mark" />
      </Match>
    </Switch>
  );
}
